<template>
    <div class="my-body">
        <div class="quick_right" :style="{'width': id>0 ? 'calc(100vw - 640px)' : '100%'}">
            <div class="clientType">
                <span :class="{'active': clientType == 1}" data-type="1" @click="changeClientType">基本信息</span>
                <span :class="{'active': clientType == 2}" data-type="2" @click="changeClientType">工作信息</span>
                <span :class="{'active': clientType == 3}" data-type="3" @click="changeClientType">资产信息</span>
                <span :class="{'active': clientType == 4}" data-type="4" @click="changeClientType">保单/社保/公积金信息</span>
                <span :class="{'active': clientType == 5}" data-type="5" @click="changeClientType">负债信息</span>
                <span :class="{'active': clientType == 6}" data-type="6" @click="changeClientType">企业信息</span>
            </div>
            <div v-if="clientType == 1">
                <div class="main_body" style="padding:15px;border-bottom: 1px solid #dcdcdc;">
                    <div class="info_title"><span>&diams;</span>基本信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css">姓名:</div>
                            <Input v-model="client.name" style="width: 170px"/>
                        </div>
						<div class="info_main_item">
						    <div class="right_title_css">手机号码:</div>
						    <Input v-model="client.phone"  style="width: 170px"/>
						</div>
						<div class="info_main_item"> 拓客状态：
							<Select @on-change="saveClient" v-model="client.status" style="width:80px">
								<Option v-for="item in stateList" :value="item.value" :key="item.value">{{ item.label }}
								</Option>
							</Select>
						</div>
                    </div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css">城市:</div>
                            <Cascader :data="cityData" v-model="client.ext_info.city" style="width: 170px"></Cascader>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css">年龄:</div>
                            <Input v-model="client.ext_info.age" style="width: 170px"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css">性别:</div>
                            <RadioGroup v-model="client.sex">
                                <Radio :label="1"><span>男</span></Radio>
                                <Radio :label="2"><span>女</span></Radio>
                            </RadioGroup>
                        </div>
                    </div>
                    <div class="main_row">
                        <!--div class="info_main_item">
                            <div class="right_title_css">身份证号码:</div>
                            <Input v-model="client.certno" style="width: 170px"/>
                        </div-->
						<div class="info_main_item">
						    <div class="right_title_css">来源:</div>
						    <Input v-model="client.source" disabled style="width: 170px"/>
						</div>
                        <div class="info_main_item">
                            <div class="right_title_css">婚姻:</div>
                            <Select v-model="client.ext_info.maritalStatus" style="width:170px">
                                <Option v-for="item in maritalList" :value="item.value" :key="item.value">{{ item.label }}
                                </Option>
                            </Select>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css">学历:</div>
                            <Select v-model="client.ext_info.education" style="width:170px">
                                <Option v-for="item in educationList" :value="item.value" :key="item.value">{{ item.label
                                    }}
                                </Option>
                            </Select>
                        </div>
                    </div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css">贷款额度:</div>
                            <Input v-model="client.loans_money" style="width: 170px;"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css">贷款周期:</div>
                            <Input v-model="client.loans_period" style="width: 170px;"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css">需求时间:</div>
                            <DatePicker :value="client.loans_time" @on-change="(e) => {client.loans_time = e}" type="date"
                                        placeholder="请选择时间"
                                        style="width: 170px"></DatePicker>
                        </div>
                    </div>
                </div>
                <div class="main_body" style="padding:15px;">
                    <div class="main_row">
                        <div class="main_item" style="width: 47%">
                            <div class="right_title_css" style="width: 120px">客户介绍:</div>
                            <Input v-model="client.ext_info.introduce" type="textarea" :rows="3"
                                   placeholder="这里请输入客户相关介绍及客户贷款真实用途或贷款原因"/>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="clientType == 2" >
                <div class="main_body" style="padding:15px;border-bottom: 1px solid #dcdcdc;">
                    <div class="info_title"><span>&diams;</span>工作信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css">客户类型:</div>
                            <Select v-model="client.ext_info.type" style="width:170px">
                                <Option v-for="item in clientTypeList" :value="item.value" :key="item.value">{{ item.label
                                    }}
                                </Option>
                            </Select>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css">职业类型:</div>
                            <Select v-model="client.ext_info.job_type" style="width:170px">
                                <Option v-for="item in jobTypeList" :value="item.value" :key="item.value">{{ item.label }}
                                </Option>
                            </Select>
                        </div>
                    </div>
                </div>
                <div class="main_body" style="padding:15px;">
                    <div class="info_title"><span>&diams;</span>收入信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css">月收入金额:</div>
                            <Input v-model="client.ext_info.income_sum" style="width: 170px;"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css">收入类型:</div>
                            <Select v-model="client.ext_info.income_type" style="width:170px">
                                <Option v-for="item in income_type_list" :value="item.value" :key="item.value">
                                    {{ item.label }}
                                </Option>
                            </Select>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="clientType == 3">
                <div class="main_body" style="padding:15px;border-bottom: 1px solid #dcdcdc;">
                    <div class="info_title"><span>&diams;</span>房产信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">房产:</div>
                            <RadioGroup v-model="client.ext_info.houseShow" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                    </div>
                    <div class="main_row" v-if="client.ext_info.houseShow == 1">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">月供房:</div>
                            <RadioGroup v-model="client.ext_info.houseMonthShow" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseMonthShow == 1">
                            <div class="right_title_css" style="width: 70px">月供金额:</div>
                            <Input v-model="client.ext_info.monthlySum" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseMonthShow == 1">
                            <div class="right_title_css" style="width: 70px">月供期数:</div>
                            <Input v-model="client.ext_info.monthlyPeriod" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseMonthShow == 1">
                            <div class="right_title_css" style="width: 70px">购房日期:</div>
                            <DatePicker :value="client.ext_info.monthly_time"
                                        @on-change="(e) => {client.ext_info.monthly_time = e}" type="month"
                                        placeholder="请选择时间"
                                        style="width: 100px"></DatePicker>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseMonthShow == 1">
                            <div class="right_title_css" style="width: 70px">房产所在地:</div>
                            <Cascader :data="cityData" v-model="client.ext_info.monthly_location" style="width: 100px"></Cascader>
                        </div>
                    </div>
                    <div class="main_row" v-if="client.ext_info.houseShow == 1">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">全款房:</div>
                            <RadioGroup v-model="client.ext_info.houseAllShow" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseAllShow == 1">
                            <div class="right_title_css" style="width: 70px">房产价值:</div>
                            <Input v-model="client.ext_info.houseSum" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseAllShow == 1">
                            <div class="right_title_css" style="width: 70px">住宅年龄:</div>
                            <Input v-model="client.ext_info.houseYears" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseAllShow == 1">
                            <div class="right_title_css" style="width: 70px">购房日期:</div>
                            <DatePicker :value="client.ext_info.buy_time"
                                        @on-change="(e) => {client.ext_info.buy_time = e}" type="month"
                                        placeholder="请选择时间"
                                        style="width: 100px"></DatePicker>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseAllShow == 1">
                            <div class="right_title_css" style="width: 70px">房产所在地:</div>
                            <Cascader :data="cityData" v-model="client.ext_info.total_location" style="width: 100px"></Cascader>
                        </div>
                    </div>
                    <div class="main_row" v-if="client.ext_info.houseShow == 1">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">宅基地/自建房:</div>
                            <RadioGroup v-model="client.ext_info.houseLandShow" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseLandShow == 1">
                            <div class="right_title_css" style="width: 70px">房产价值:</div>
                            <Input v-model="client.ext_info.houseSelfSum" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseLandShow == 1">
                            <div class="right_title_css" style="width: 70px">房屋面积:</div>
                            <Input v-model="client.ext_info.houseSelfArea" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseLandShow == 1">
                            <div class="right_title_css" style="width: 70px">购房日期:</div>
                            <DatePicker :value="client.ext_info.self_buy_time"
                                        @on-change="(e) => {client.ext_info.self_buy_time = e}" type="month"
                                        placeholder="请选择时间"
                                        style="width: 100px"></DatePicker>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.houseLandShow == 1">
                            <div class="right_title_css" style="width: 70px">房产所在地:</div>
                            <Cascader :data="cityData" v-model="client.ext_info.self_total_location" style="width: 100px"></Cascader>
                        </div>
                    </div>
                </div>
                <div class="main_body" style="padding:15px;">
                    <div class="info_title"><span>&diams;</span>车产信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">车产:</div>
                            <RadioGroup v-model="client.ext_info.carShow" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                    </div>
                    <div class="main_row" v-if="client.ext_info.carShow == 1">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">月供车:</div>
                            <RadioGroup v-model="client.ext_info.carMonthShow" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.carMonthShow == 1">
                            <div class="right_title_css" style="width: 70px">月供金额:</div>
                            <Input v-model="client.ext_info.carSum" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.carMonthShow == 1">
                            <div class="right_title_css" style="width: 70px">开始月供日期:</div>
                            <DatePicker :value="client.ext_info.buy_car_time"
                                        @on-change="(e) => {client.ext_info.buy_car_time = e}" type="date"
                                        placeholder="请选择时间"
                                        style="width: 100px"></DatePicker>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.carMonthShow == 1">
                            <div class="right_title_css" style="width: 70px">车牌归属地:</div>
                            <Input v-model="client.ext_info.car_location" style="width: 100px;"/>
                        </div>
                    </div>
                    <div class="main_row" v-if="client.ext_info.carShow == 1">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">全款车:</div>
                            <RadioGroup v-model="client.ext_info.carAllShow" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.carAllShow == 1">
                            <div class="right_title_css" style="width: 70px">车产价值:</div>
                            <Input v-model="client.ext_info.carTotalSum" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.carAllShow == 1">
                            <div class="right_title_css" style="width: 70px">持证日期:</div>
                            <DatePicker :value="client.ext_info.car_id_time"
                                        @on-change="(e) => {client.ext_info.car_id_time = e}" type="date"
                                        placeholder="请选择时间"
                                        style="width: 100px"></DatePicker>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.carAllShow == 1">
                            <div class="right_title_css" style="width: 70px">车牌归属地:</div>
                            <Input v-model="client.ext_info.total_car_location" style="width: 100px;"/>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="clientType == 4">
                <div class="main_body" style="padding:15px;border-bottom: 1px solid #dcdcdc;">
                    <div class="info_title"><span>&diams;</span>保单信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">保单:</div>
                            <RadioGroup v-model="client.ext_info.policyShow" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                    </div>
                    <div class="main_row" v-if="client.ext_info.policyShow == 1">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">保单名称:</div>
                            <Input v-model="policy.policy_name" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">购买日期:</div>
                            <DatePicker :value="policy.policy_buy_time" @on-change="(e) => {policy.policy_buy_time = e}"
                                        type="date"
                                        placeholder="请选择时间" style="width: 100px"></DatePicker>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">总共应缴期数:</div>
                            <Input v-model="policy.total_due_periods" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">投保人:</div>
                            <Select v-model="policy.policy_people_name" style="width: 100px">
                                <Option v-for="item in policy_people_name_list" :value="item.value" :key="item.value">{{
                                    item.label }}
                                </Option>
                            </Select>
                        </div>
                    </div>
                    <div class="main_row" v-if="client.ext_info.policyShow == 1">
                        <div class="info_main_item" >
                            <div class="right_title_css" style="width: 70px">缴费方式:</div>
                            <Select v-model="policy.payment_type" style="width: 100px">
                                <Option v-for="item in payment_type_list" :value="item.value" :key="item.value">{{
                                    item.label }}
                                </Option>
                            </Select>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">缴纳金额:</div>
                            <Input v-model="policy.payment_payment_sum" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">保单类型:</div>
                            <Select v-model="policy.policy_type" style="width: 100px">
                                <Option v-for="item in policy_type_list" :value="item.value" :key="item.value">{{ item.label
                                    }}
                                </Option>
                            </Select>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">是否有断缴:</div>
                            <Select v-model="policy.policy_stop" style="width: 100px">
                                <Option v-for="item in policy_stop_list" :value="item.value" :key="item.value">{{ item.label
                                    }}
                                </Option>
                            </Select>
                        </div>
                        <div class="info_main_item">
                            <Button type="primary" style="margin-left: 100px;" @click="savePolicy">添加</Button>
                        </div>
                    </div>
                    <div v-if="client.ext_info.policyShow == '1' ">
                        <div class="main_row" style="justify-content: space-between; padding-left: 30px; width: 60%" v-for="(item, index) in policyList"
                             :key="index">
                            <span class="icon iconfont icon-biaoji_" style="font-size: 10px;"></span>
                            <span>{{item.policy_name}}</span>
                            <span>{{item.policy_buy_time}}</span>
                            <span>总缴{{item.total_due_periods}}期</span>
                            <span>{{item.policy_people_name}}</span>
                            <span>月交{{item.payment_payment_sum}}元</span>
                            <span>{{item.payment_type}}</span>
                            <span>{{item.policy_stop == 1 ? '有' : '无'}}断缴</span>
                            <span style="color: red; cursor: pointer;">删除</span>
                        </div>
                    </div>
                </div>
                <div class="main_body" style="padding:15px;border-bottom: 1px solid #dcdcdc;">
                    <div class="info_title"><span>&diams;</span>社保信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">社保:</div>
                            <RadioGroup v-model="client.ext_info.social_security_show" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.social_security_show == 1">
                            <div class="right_title_css" style="width: 70px">本单位社保购买日期:</div>
                            <DatePicker :value="client.ext_info.social_security_buy_time"
                                        @on-change="(e) => {client.ext_info.social_security_buy_time = e}" type="date"
                                        placeholder="请选择时间" style="width: 100px"></DatePicker>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.social_security_show == 1">
                            <div class="right_title_css" style="width: 70px">社保基数:</div>
                            <Input v-model="client.ext_info.social_security_cardinal_number" style="width: 100px;"/>
                        </div>
                    </div>
                </div>
                <div class="main_body" style="padding:15px;">
                    <div class="info_title"><span>&diams;</span>公积金信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">公积金:</div>
                            <RadioGroup v-model="client.ext_info.accumulation_fund_show" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.accumulation_fund_show == 1">
                            <div class="right_title_css" style="width: 70px">本单位公积金购买日期:</div>
                            <DatePicker :value="client.ext_info.accumulation_fund_buy_time"
                                        @on-change="(e) => {client.ext_info.accumulation_fund_buy_time = e}" type="date"
                                        placeholder="请选择时间" style="width: 100px"></DatePicker>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.accumulation_fund_show == 1">
                            <div class="right_title_css" style="width: 70px">公积金基数:</div>
                            <Input v-model="client.ext_info.accumulation_fund_cardinal_number" style="width: 100px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.accumulation_fund_show == 1">
                            <div class="right_title_css" style="width: 70px">个人缴纳金额:</div>
                            <Input v-model="client.ext_info.accumulation_fund_self_number" style="width: 100px;"/>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="clientType == 5">
                <div class="main_body" style="padding:15px;">
                    <div class="info_title"><span>&diams;</span>负债信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">负债:</div>
                            <RadioGroup v-model="client.ext_info.debt_show" style="width: 100px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                    </div>
                    <div class="main_row" v-if="client.ext_info.debt_show == 1 ">
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">资方名称:</div>
                            <Input v-model="debt.capital_name " style="width: 100px;"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">放款金额:</div>
                            <Input v-model="debt.loan_sum " style="width: 100px;"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">借款周期:</div>
                            <Input v-model="debt.borrower_period " style="width: 100px;"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css" style="width: 70px">放款日期:</div>
                            <DatePicker :value="debt.loan_date" @on-change="(e) => {debt.loan_date = e}" type="date"
                                        placeholder="请选择时间"
                                        style="width: 100px"></DatePicker>
                        </div>
                        <div class="info_main_item">
                            <Button type="primary" style="margin-left: 100px;" @click="saveDebt">添加</Button>
                        </div>
                    </div>
                    <div v-if="client.ext_info.debt_show == '1'">
                        <div class="main_row" style="justify-content: space-between; padding-left: 30px; width: 50%"
                             v-for="(item, index) in debtList" :key="index">
                            <span class="icon iconfont icon-biaoji_" style="font-size: 10px;"></span>
                            <span>{{item.capital_name}}</span>
                            <span>贷款额度{{item.loan_sum}}</span>
                            <span>借贷款期限{{item.borrower_period}}个月</span>
                            <span>{{item.loan_date}}</span>
                            <span style="color: red; cursor: pointer;">删除</span>
                        </div>
                    </div>
                </div>
                <div class="main_body" style="padding:15px;border-bottom: 1px solid #dcdcdc;">
                    <div class="info_title"><span>&diams;</span>信用信息</div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css">芝麻信用分:</div>
                            <Input v-model="client.ext_info.zhima_credit" style="width: 170px"/>
                        </div>
                        <div class="info_main_item">
                            <div class="right_title_css">微粒贷:</div>
                            <RadioGroup v-model="client.ext_info.weilidaiShow" style="width: 170px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.weilidaiShow == 1 ">
                            <div class="right_title_css">微粒贷额度:</div>
                            <Input v-model="client.ext_info.weilidai_sum"
                                   style="width: 170px;"/>
                        </div>
                    </div>
                    <div class="main_row">
                        <div class="info_main_item">
                            <div class="right_title_css">信用卡:</div>
                            <RadioGroup v-model="client.ext_info.credit_card_show" style="width: 170px">
                                <Radio :label="0"><span>无</span></Radio>
                                <Radio :label="1"><span>有</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.credit_card_show == 1 ">
                            <div class="right_title_css">发卡银行:</div>
                            <Input v-model="credit_card.issuing_bank" style="width: 170px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.credit_card_show == 1 ">
                            <div class="right_title_css">额度:</div>
                            <Input v-model="credit_card.issuing_bank_sum" style="width: 170px;"/>
                        </div>
                        <div class="info_main_item" v-if="client.ext_info.credit_card_show == 1 ">
                            <Button type="primary" style="margin-left: 100px;" @click="saveCreditCard">添加</Button>
                        </div>
                    </div>
                    <div v-if="client.ext_info.credit_card_show == '1'">
                        <div class="main_row" style="justify-content: space-between; padding-left: 30px; width: 40%"
                             v-for="(item, index) in creditCardList" :key="index">
                            <span class="icon iconfont icon-biaoji_" style="font-size: 10px;"></span>
                            <span>{{item.issuing_bank}}</span>
                            <span>信用卡额度：{{item.issuing_bank_sum}}</span>
                            <span style="color: red; cursor: pointer;">删除</span>
                        </div>
                    </div>
                </div>
				<div class="main_body" style="padding:15px;border-bottom: 1px solid #dcdcdc;">
				    <div class="info_title"><span>&diams;</span>征信情况</div>
				    <div class="main_row">
				        <div class="info_main_item">
				            <div class="right_title_css">当前:</div>
				            <RadioGroup v-model="client.ext_info.overdue_or" style="width: 170px">
				                <Radio :label="0"><span>无逾期</span></Radio>
				                <Radio :label="1"><span>有逾期</span></Radio>
				            </RadioGroup>
				        </div>
				        <div class="info_main_item" v-if="client.ext_info.overdue_or == 1">
				            <div class="right_title_css">当前逾期金额:</div>
				            <Input  v-model="client.ext_info.overdue_sum" style="width: 170px;"/>
				        </div>
				    </div>
				    <div class="main_row">
				        <div class="info_main_item">
				            <div class="right_title_css">近6个月:</div>
				            <RadioGroup v-model="client.ext_info.overdue_or_6" style="width: 170px">
				                <Radio :label="0"><span>无逾期</span></Radio>
				                <Radio :label="1"><span>有逾期</span></Radio>
				            </RadioGroup>
				        </div>
				        <div class="info_main_item" v-if="client.ext_info.overdue_or_6 == 1">
				            <div class="right_title_css">逾期次数:</div>
				            <Input  v-model="client.ext_info.overdue_6_number" style="width: 170px;"/>
				        </div>
				        <div class="info_main_item" v-if="client.ext_info.overdue_or_6 == 1">
				            <div class="right_title_css">逾期天数:</div>
				            <Input  v-model="client.ext_info.overdue_6_days" style="width: 170px;"/>
				        </div>
				    </div>
				    <div class="main_row">
				        <div class="info_main_item">
				            <div class="right_title_css">近12个月:</div>
				            <RadioGroup v-model="client.ext_info.overdue_or_12" style="width: 170px">
				                <Radio :label="0"><span>无逾期</span></Radio>
				                <Radio :label="1"><span>有逾期</span></Radio>
				            </RadioGroup>
				        </div>
				        <div class="info_main_item" v-if="client.ext_info.overdue_or_12 == 1">
				            <div class="right_title_css">逾期次数:</div>
				            <Input  v-model="client.ext_info.overdue_12_number" style="width: 170px;"/>
				        </div>
				        <div class="info_main_item" v-if="client.ext_info.overdue_or_12 == 1">
				            <div class="right_title_css">逾期天数:</div>
				            <Input  v-model="client.ext_info.overdue_12_days" style="width: 170px;"/>
				        </div>
				    </div>
				    <div class="main_row">
				        <div class="info_main_item">
				            <div class="right_title_css">近24个月:</div>
				            <RadioGroup v-model="client.ext_info.overdue_or_24" style="width: 170px">
				                <Radio :label="0"><span>无逾期</span></Radio>
				                <Radio :label="1"><span>有逾期</span></Radio>
				            </RadioGroup>
				        </div>
				        <div class="info_main_item" v-if="client.ext_info.overdue_or_24 == 1">
				            <div class="right_title_css">逾期次数:</div>
				            <Input  v-model="client.ext_info.overdue_24_number" style="width: 170px;"/>
				        </div>
				        <div class="info_main_item" v-if="client.ext_info.overdue_or_24 == 1">
				            <div class="right_title_css">逾期天数:</div>
				            <Input  v-model="client.ext_info.overdue_24_days" style="width: 170px;"/>
				        </div>
				    </div>
				</div>
            </div>
            <div v-if="clientType == 6">
                <div class="main_body" style="padding:15px;border-bottom: 1px solid #dcdcdc;">
                    <div class="info_title"><span>&diams;</span>基本信息</div>
                    <div class="main_row">
                        <div class="company_main_item">
                            <div class="right_title_css">企业名称:</div>
                            <Input v-model="firm.name" style="width: 170px;"/>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">企业职务:</div>
                            <Select v-model="firm.identity" style="width: 170px">
                                <Option v-for="item in identityList" :value="item.value" :key="item.value">
                                    {{ item.label}}
                                </Option>
                            </Select>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">持股占比:</div>
                            <Input v-model="firm.stock" style="width: 170px;"/>
                        </div>
                    </div>
                    <div class="main_row">
                        <div class="company_main_item">
                            <div class="right_title_css">行业:</div>
                            <Input v-model="firm.business" style="width: 170px;"/>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">企业税号:</div>
                            <Input v-model="firm.tax_number" style="width: 170px;"/>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">税务密码:</div>
                            <Input v-model="firm.tax_password" style="width: 170px;"/>
                        </div>
                    </div>
                    <div class="main_row">
                        <div class="company_main_item">
                            <div class="right_title_css">企业注册日期:</div>
                            <DatePicker type="date" :value="firm.register_date" @on-change="(e) => {firm.register_date = e}"
                                        style="width: 170px"></DatePicker>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">经营时长:</div>
                            <div>
                                <i-input v-model="firm.manage_time" style="width: 140px;"></i-input>
                                <span class="append">年</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main_body" style="padding:15px;border-bottom: 1px solid #dcdcdc;">
                    <div class="info_title"><span>&diams;</span>公司经营流水</div>
                    <div class="main_row">
                        <div class="company_main_item">
                            <div class="right_title_css">每月流水:</div>
                            <div>
                                <i-input v-model="firm.water_sum" style="width: 140px;"></i-input>
                                <span class="append">万</span>
                            </div>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">连续可提供流水时长:</div>
                            <div>
                                <i-input v-model="firm.water_time" style="width: 140px;"></i-input>
                                <span class="append">月</span>
                            </div>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">账户流动资金金额:</div>
                            <div>
                                <i-input v-model="firm.fund_sum" style="width: 140px;"></i-input>
                                <span class="append">万</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main_body" style="padding:15px;">
                    <div class="info_title"><span>&diams;</span>公司纳税</div>
                    <div class="main_row">
                        <div class="company_main_item">
                            <div class="right_title_css">公司纳税类型:</div>
                            <Select v-model="firm.ratepaying_type" style="width: 170px">
                                <Option v-for="item in ratepaying_type_list" :value="item.value" :key="item.value">{{
                                    item.label }}
                                </Option>
                            </Select>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">近一年纳税金额:</div>
                            <div>
                                <i-input v-model="firm.year_ratepaying_sum" style="width: 140px;"></i-input>
                                <span class="append">元</span>
                            </div>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">近两年纳税金额:</div>
                            <div>
                                <i-input v-model="firm.two_year_ratepaying_sum" style="width: 140px;"></i-input>
                                <span class="append">元</span>
                            </div>
                        </div>
                    </div>
                    <div class="main_row">
                        <div class="company_main_item">
                            <div class="right_title_css">最近连续纳税时长:</div>
                            <div>
                                <i-input v-model="firm.ratepaying_duration" style="width: 140px;"></i-input>
                                <span class="append">月</span>
                            </div>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">最近1年0申报次数:</div>
                            <div>
                                <i-input v-model="firm.declaration_number" style="width: 140px;"></i-input>
                                <span class="append">次</span>
                            </div>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">月均开票金额:</div>
                            <div>
                                <i-input v-model="firm.invoice_month_sum" style="width: 140px;"></i-input>
                                <span class="append">万</span>
                            </div>
                        </div>
                    </div>
                    <div class="main_row">
                        <div class="company_main_item">
                            <div class="right_title_css">近一年开票总额:</div>
                            <div>
                                <i-input v-model="firm.invoice_year_sum" style="width: 140px;"></i-input>
                                <span class="append">万</span>
                            </div>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">开票时长(月):</div>
                            <div>
                                <i-input v-model="firm.invoice_duration" style="width: 140px;"></i-input>
                                <span class="append">月</span>
                            </div>
                        </div>
                        <div class="company_main_item">
                            <div class="right_title_css">企业信用评级:</div>
                            <Select v-model="firm.credit_rate" style="width: 170px">
                                <Option value="A">A级</Option>
                                <Option value="B">B级</Option>
                                <Option value="C">C级</Option>
                                <Option value="D">D级</Option>
                                <Option value="M">M级</Option>
                            </Select>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 按钮 -->
            <div style="position:absolute; bottom: 5%; right: 3%">
                <Button type="primary" style="width: 170px;" @click="save">保存资料</Button>
            </div>
        </div>
    </div>
</template>
<script>
    import cityData from '../../assets/citydata.js'
    import ClientMessage from './ClientMessage.vue'
    import {addClient, savePolicy, saveCreditCard, saveDebt, getClient, saveComment, cancelTag,addVisit,saveClient} from '@/api/client'
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "addClent",
        components: {
            ClientMessage
        },
        computed: {
            ...mapGetters(['userInfo', 'token'])
        },
        props: ['id','isIntroduce'],
        data() {
            return {
                clientType: 1,
                loanFoldShow: false,
                viewFoldShow: false,
                distributionFoldShow: false,
                commentFoldShow: false,
                followFoldShow: false,
				editTaskOp: false,
				addVisitModal: false,
				status:'',
				viewed_at:'',
                tabsList: [
                ],
				stateList: [
				    {
				        value: 1,
				        label: '未上门'
				    },
				    {
				        value: 2,
				        label: '已上门未能转化'
				    },
				    {
				        value: 3,
				        label: '已上门还可跟进'
				    },
				    {
				        value: 4,
				        label: '转化成功'
				    }
				],
                firm: {
                    name: '',
                    identity: '0',
                    stock: '',
                    business: '',
                    tax_number: '',
                    tax_password: '',
                    register_date: '',
                    manage_time: '',
                    water_sum: '',
                    water_time: '',
                    fund_sum: '',
                    ratepaying_type: '0',
                    year_ratepaying_sum: '',
                    two_year_ratepaying_sum: '',
                    ratepaying_duration: '',
                    declaration_number: '',
                    invoice_month_sum: '',
                    invoice_year_sum: '',
                    invoice_duration: '',
                    credit_rate: '',
                },
                ratepaying_type_list: [{
                    value: '1',
                    label: '小规模纳税'
                },{
                    value: '2',
                    label: '一般纳税人'
                },],
                identityList: [{
                    value: '1',
                    label: '法人'
                },{
                    value: '2',
                    label: '股东'
                },{
                    value: '3',
                    label: '监事'
                },],
                left_pages_show: true,

                remarkValue: '',
                cityData: cityData,
                client_message: {
                    profession: '',
                    income: '',
                    income_sum: '',
                    house: '',
                    house_sum: '',
                    car: '',
                    car_sum: '',
                    accumulation_fund: '',
                    accumulation_fund_time: '',
                    social_security: '',
                    commercial_insurance: '',
                    commercial_insurance_date: '',
                    wei_li_dai: '',
                    wei_li_dai_sum: '',
                    credit_card: '',
                    credit_card_sum: '',
                    liabilities: '',
                    liabilities_money: '',
                },
                client: {
                    phone: '',
                    certno: '',
                    loans_money: '',
                    loans_period: '',
                    loans_time: '',
                    ext_info: {
                        age: '',
                        education: '0',
                        maritalStatus: '0',
                        job_type: '0',
                        houseShow: 1,
                        houseMonthShow: 1,
                        houseAllShow: 1,
                        houseLandShow: 1,
                        monthlySum: '',
                        monthlyPeriod: '',
                        monthly_time: '',
                        monthly_location: [],
                        houseSum: '',
                        houseYears: '',
                        buy_time: '',
                        total_location: [],
                        houseSelfSum: '',
                        houseSelfArea: '',
                        self_buy_time: '',
                        self_total_location: [],
                        carShow: '1',
                        carMonthShow: '1',
                        carAllShow: '1',
                        monthly_car_show: '1',
                        carSum: '',
                        buy_car_time: '',
                        car_location: '',
                        total_car_show: '1',
                        carTotalSum: '',
                        car_id_time: '',
                        total_car_location: '',
                        policyShow: '1',
                        social_security_show: '1',
                        social_security_buy_time: '',
                        social_security_cardinal_number: '',
                        accumulation_fund_show: '1',
                        accumulation_fund_buy_time: '',
                        accumulation_fund_cardinal_number: '',
                        accumulation_fund_self_number: '',
                        income_sum: '',
                        income_type: '0',
                        zhima_credit: '0',
                        weilidaiShow: '1',
                        weilidai_sum: '',
                        credit_card_show: '1',
                        debt_show: '1',
                        city: [],
                        introduce: '',
                        overdue_or: 0,
                        overdue_sum: '',
                        overdue_or_6: '',
                        overdue_or_12: '',
                        overdue_or_24: '',
                        overdue_6_number: '',
                        overdue_6_days: '',
                        overdue_12_number: '',
                        overdue_12_days: '',
                        overdue_24_number: '',
                        overdue_24_days: '',
                        unit_name: '',
                        unit_contacts_name: '',
                        unit_contacts_phone: '',
                        unit_site: '',
                        unit_entry_time: '',
                    },
                    type: 0,
                    name: '',
                    sex: 0,
                    source: '',
                    applied_at: '',
                },
                maritalList: [{
                    value: 1,
                    label: '已婚'
                },
                    {
                        value: 2,
                        label: '未婚'
                    },
                    {
                        value: 3,
                        label: '离异'
                    },
                    {
                        value: 4,
                        label: '丧偶'
                    },
                ],
                educationList: [{
                    value: '1',
                    label: '高中及以下'
                },{
                    value: '2',
                    label: '大专'
                },{
                    value: '3',
                    label: '本科'
                },
                    {
                        value: '4',
                        label: '研究生及以上'
                    },
                ],
                clientTypeList: [{
                    value: '1',
                    label: '授薪'
                },{
                    value: '2',
                    label: '自雇'
                },],
                jobTypeList: [
                    {
                        value: '1',
                        label: '公务员或事业单位'
                    },
                    {
                        value: '2',
                        label: '上班族'
                    },
                    {
                        value: '3',
                        label: '个体户、企业主或股东'
                    },
                    {
                        value: '4',
                        label: '自由职业'
                    },
                    {
                        value: '5',
                        label: '学生'
                    },
                ],
                policy_people_name_list: [{
                    value: '本人',
                    label: '本人'
                }, {
                    value: '他人',
                    label: '他人'
                },],
                payment_type_list: [
                    {
                        value: '年交',
                        label: '年交'
                    },
                    {
                        value: '月交',
                        label: '月交'
                    },
                    {
                        value: '季交',
                        label: '季交'
                    },
                    {
                        value: '趸交',
                        label: '趸交'
                    },
                ],
                policy_type_list: [
                    {
                        value: '寿险年金',
                        label: '寿险年金'
                    },
                    {
                        value: '分红型',
                        label: '分红型'
                    },
                    {
                        value: '传统型',
                        label: '传统型'
                    },
                    {
                        value: '大病型',
                        label: '大病型'
                    },
                    {
                        value: '趸交型',
                        label: '趸交型'
                    },
                    {
                        value: '其他类型',
                        label: '其他类型'
                    },
                ],
                policy_stop_list: [
                    {
                        value: '1',
                        label: '有'
                    },
                    {
                        value: '0',
                        label: '无'
                    }
                ],
                income_type_list: [{
                    value: '1',
                    label: '银行代发(扣税)'
                },
                    {
                        value: '2',
                        label: '银行转账'
                    },
                    {
                        value: '3',
                        label: '微信、支付宝或现金'
                    },
                    {
                        value: '4',
                        label: '股东分红或利润'
                    },
                    {
                        value: '5',
                        label: '其他'
                    }],
                nowTime: '',
                //保单信息
                policy: {
                    policy_name: '',
                    policy_buy_time: '',
                    total_due_periods: '',
                    policy_people_name: '0',
                    payment_type: '0',
                    payment_payment_sum: '0',
                    policy_type: '0',
                    policy_stop: '0',
                },
                policyList: [],
                // 信用卡
                credit_card: {
                    issuing_bank: '',
                    issuing_bank_sum: '',
                },
                creditCardList: [],
                // 负债信息
                debt: {
                    capital_name: '',
                    loan_sum: '',
                    borrower_period: '',
                    loan_date: '',
                },
                debtList: [],
                followLogList: [],
                commentLogList: [],
                contactLogList: [],
                distributionLogList: [],
                viewLogList: [],
                loanLogList: [],
				viewList:[],

            }
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            handleClose(type, id) {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, client_id: that.client.id, type:type, tag: id};
                    let res = await cancelTag(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.loadData()
                    }
                }, 500)
            },
            async loadData() {
                let that = this;
                var date = new Date();
                this.nowTime = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
                if (that.id != 0) {
					
                    let data = {token: that.token, id: that.id};
                    let res = await getClient(that, data);
                    if (res.code == 1) {
                        that.client = res.data.item;
                        that.firm = res.data.item.ext_info.firm;
                        that.policyList = res.data.policyList;
                        that.creditCardList = res.data.creditCardList;
                        that.debtList = res.data.debtList;
                        that.followLogList = res.data.followLogList;
                        that.commentLogList = res.data.commentLogList;
                        that.contactLogList = res.data.contactLogList;
                        that.viewLogList = res.data.viewLogList;
						that.viewList = res.data.viewList;
						that.introduceList = res.data.introduceList;
                        that.loanLogList = res.data.loanLogList;
                        that.distributionLogList = res.data.distributionLogList;
                        that.tabsList = res.data.tabsList;
                        that.client_message = res.data.info;
                    }
                }
                that.$emit('reloadData');
            },
            save() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, data: that.client};
					data.isIntroduce = that.isIntroduce;
					data.client_id = that.id;
                    data.data.firm = that.firm;
                    let res = await addClient(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        if (that.id == 0) {
                            that.id = res.data.id;
                        }
                        that.loadData();
                    }
                }, 500)
            },
			saveClient() {
			    let that = this;
			    this.throttle(async function () {
			        let data = {token: that.token, data: that.client};
			        data.data.firm = that.firm;
			        let res = await saveClient(that, data);
			        if (res.code == 1) {
			            that.$Message.success(res.msg);
			            that.loadData();
			            that.$emit('reloadData');
			        }
			    }, 500)
			},
			makeTimeChange(e) {
			    this.viewed_at = e
			},
            savePolicy() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, data: that.policy, client_id: that.id};
                    let res = await savePolicy(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.policy = {
                            policy_name: '',
                            policy_buy_time: '',
                            total_due_periods: '',
                            policy_people_name: '0',
                            payment_type: '0',
                            payment_payment_sum: '0',
                            policy_type: '0',
                            policy_stop: '0',
                        };
                        that.loadData();
                    }
                }, 500)
            },
            saveCreditCard() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, data: that.credit_card, client_id: that.id};
                    let res = await saveCreditCard(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.credit_card = {
                            issuing_bank: '',
                            issuing_bank_sum: '',
                        };
                        that.loadData();
                    }
                }, 500)
            },
            saveDebt() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, data: that.debt, client_id: that.id};
                    let res = await saveDebt(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.debt = {
                            capital_name: '',
                            loan_sum: '',
                            borrower_period: '',
                            loan_date: '',
                        };
                        that.loadData();
                    }
                }, 500)
            },
            saveComment() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, remark: that.remarkValue, client_id: that.id};
                    let res = await saveComment(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.remarkValue = '';
                        that.loadData();
                    }
                }, 500)
            },
            changeClientType(e) {
                this.clientType = e.currentTarget.dataset.type;
            },
            addVisit() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, viewed_at: that.viewed_at, visit_id: that.id,status:that.status};
                    let res = await addVisit(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.addVisitModal = false;
                        that.loadData();
                    }
                }, 500)
            },
            beforeOne() {
                let that = this;
                this.$nextTick(() => {
                    that.$emit('beforeOne');
                })
            },
            nextOne() {
                let that = this;
                this.$nextTick(() => {
                    that.$emit('nextOne');
                })
            }
        },
        filters: {
        }
    }
</script>
<style scoped lang="less">
    .black_css {
        color: #FFFFFF;
        background-color: #000000;
    }

    .violet_css {
        color: #FFFFFF;
        background-color: #9801FE;
    }

    .green_css {
        color: #FFFFFF;
        background-color: #8FC31F;
    }

    .grey_css {
        color: #FFFFFF;
        background-color: #BFBFBF;
    }

    .orange_css {
        color: #FFFFFF;
        background-color: #EB6100;
    }

    .red_css {
        color: #FFFFFF;
        background-color: #E60012;
    }

    .blue_css {
        color: #FFFFFF;
        background-color: #21A0FF;
    }

    .aaa_css {
        color: #FFFFFF;
        background-color: #E968A1;
    }

    .bbb_css {
        color: #FFFFFF;
        background-color: #FED600;
    }

    .ccc_css {
        color: #FFFFFF;
        background-color: #FF5E5A;
    }

    .ddd_css {
        color: #FFFFFF;
        background-color: #843900;
    }

    .eee_css {
        color: #FFFFFF;
        background-color: #181D4B;
    }

    .fff_css {
        color: #FFFFFF;
        background-color: #007D65;
    }

    .ggg_css {
        color: #FFFFFF;
        background-color: #1D953F;
    }

    .hhh_css {
        color: #FFFFFF;
        background-color: #CA8687;
    }

    .iii_css {
        color: #FFFFFF;
        background-color: #596032;
    }

    .jjj_css {
        color: #FFFFFF;
        background-color: #F36C21;
    }

    .right_title_css {
        color: black;
        width: 110px;
        text-align: right;
        margin-right: 10px;
        /*font-weight: bold;*/
    }

    .right_title {
        color: black;
        width: 100px;
        text-align: right;
        margin-right: 10px;
        /*font-weight: bold;*/
    }

    .right_list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 10px 0;
    }

    .right_margin {
        margin: 5px 0;
        color: #A39A96;
    }

    .my-body {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .quick_left{
        width: 800px;
    }
    .quick_right{
        width: calc(100vw - 640px);
        background: white;
        margin-left: 10px;
        border-radius: 5px;
    }
    .yl-flex {
        width: 100%;
        padding-bottom: 50px;
    }

    .flex_between {
        display: flex;
        justify-content: space-between;
        align-items: flex-start !important;
    }

    .title_margin {
        margin: 0 5px;
    }

    .client_list_flex {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    .left_title_css {
        font-weight: bold;
        width: 90px;
    }

    .left_pages {
        width: 100px;
        border: 1px solid #BEBEBE;
        text-align: center;
        cursor: pointer;
    }

    .left_pages_active {
        border: 1px solid #21A0FF;
        color: #21A0FF;
    }

    .client_detail {


        div {
            width: 100%;
            margin: 2px 0;
            display: flex;
            justify-content: space-between;

            div {
                width: 50%;
            }
        }
    }

    .add_area {
        flex-wrap: wrap;
        border: 1px solid #DBDBDB;
        padding: 5px;
        border-radius: 5px;
        padding-top: 10px
    }
    .main_bg{
        background: white;
        border-radius: 5px;
    }
    .main_header{
        font-size: 16px;
        font-weight: bold;
        color: #2A8BF6;
        border-bottom: 1px solid #dadada;
        padding: 10px 0;
        text-indent:1.5em;
    }
    .main_body{
        padding: 5px;
    }
    .main_item{
        width: 25%;
        display: flex;
        justify-content: start;
        align-items: center;
    }
    .info_main_item{
        width: 20%;
        display: flex;
        justify-content: start;
        align-items: center;
    }
    .company_main_item{
        width: 30%;
        display: flex;
        justify-content: start;
        align-items: center;
    }
    .main_row{
        display: flex;
        justify-content: start;
        align-items: center;
        padding: 5px 0;
    }
    .clientType{
        font-size: 16px;
        color: black;
        border-bottom: 1px solid #dadada;
        padding: 10px 0px;
        span{
            padding: 10px 20px;
        }
        .active{
            font-weight: bold;
            color: #2A8BF6;
            padding: 10px 20px;
            border-bottom: 4px solid #2A8BF6;
        }
    }
    .info_title{
        font-size: 15px;
        font-weight: bold;
        padding: 2px 28px;
        color: black;
        span{
            color: #2A8BF6;
            font-size: 23px;
            padding-right: 5px;
        }
    }
    .append{
        background: #eeeeee;
        padding: 8px 9px;
        vertical-align: middle;
        margin-left: -2px;
        z-index: 9;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
    .clientInfo{
        background: white;
        padding: 5px 20px;
        margin-top: 10px;
        border-radius: 5px;
    }
    .add_record_header{
        font-size: 16px;
        font-weight: bold;
        color: #2A8BF6;
    }
    .white_bg{
        position: relative;
        background-color: white;
        padding: 10px;
        margin-top: 10px;
        border-radius: 5px;
    }
	.inline {
	    display:inline-block;
	    width: 30%;
	}
    .clientTag {
        display: flex;align-items: center; flex-wrap: wrap;
    }
    .fold_class{
        color: #277dd3; position:absolute; right: 3%; bottom: 12%
    }
</style>
